import React, { useState, useEffect } from 'react';
import './leave.css'; // Your updated CSS file
import FormAside from './FormAside';
import ProjectManagerAside from './ProjectManagerAside';

const LeavePortal = () => {
  const [leaveForm, setLeaveForm] = useState({
    leaveType: '',
    startDate: '',
    endDate: '',
    reason: '',
    photo: null,
  });

  const [leaveResponse, setLeaveResponse] = useState(null);
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Employee details from localStorage
  const [empId, setEmpId] = useState('');
  const [empName, setEmpName] = useState('');
  const [designation, setDesignation] = useState('');

  // Fetch employee details from localStorage
  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    if (storedEmpId && storedEmpName && storedDesignation) {
      setEmpId(storedEmpId);
      setEmpName(storedEmpName);
      setDesignation(storedDesignation);
    } else {
      alert('Session expired. Please log in again.');
      window.location.href = '/login'; // Redirect to login page if not logged in
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLeaveForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setLeaveForm((prev) => ({
      ...prev,
      photo: e.target.files[0],
    }));
  };

  const handleLeaveSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('leave_type', leaveForm.leaveType);
    formData.append('start_date', leaveForm.startDate);
    formData.append('end_date', leaveForm.endDate);
    formData.append('reason_for_leave', leaveForm.reason);
    formData.append('empId', empId);
    formData.append('empName', empName);
    formData.append('designation', designation);

    if (leaveForm.photo) {
      formData.append('photo', leaveForm.photo);
    }

    try {
      const response = await fetch('https://cleezoclass.com:8443/api/leave-request', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.statusText}`);
      }

      const data = await response.json();
      setMessage({
        text: data.message || 'Leave request submitted successfully!',
        type: 'success',
      });

      // Reset form after successful submission
      setLeaveForm({
        leaveType: '',
        startDate: '',
        endDate: '',
        reason: '',
        photo: null,
      });
    } catch (error) {
      console.error('Error submitting leave request:', error);
      setMessage({ text: 'Error submitting leave request', type: 'error' });
    }
  };

  const handleViewLeaveResponse = async () => {
    if (!empId) {
      alert('Employee ID not found. Please log in again.');
      return;
    }

    setLoadingResponse(true);
    try {
      const response = await fetch(`https://cleezoclass.com:8443/api/leave-response/${empId}`);
      const data = await response.json();

      if (response.ok) {
        setLeaveResponse(data);
      } else {
        setLeaveResponse(null);
        alert(data.message || 'No leave response found');
      }
    } catch (error) {
      alert('Error fetching leave response');
    } finally {
      setLoadingResponse(false);
    }
  };

  return (
    <div className="leave-portal-container">
      
      {/* <ProjectManagerAside /> */}
      <form onSubmit={handleLeaveSubmit} className="leave-form">
        {/* Employee Details Row */}
        <div className="leave-row">
          <div className="form-group full-width">
            <label htmlFor="empId">Emp Id</label>
            <input
              id="empId"
              type="text"
              value={empId}
              readOnly
              placeholder="Employee ID"
            />
          </div>
          <div className="form-group full-width">
            <label htmlFor="empName">Emp Name</label>
            <input
              id="empName"
              type="text"
              value={empName}
              readOnly
              placeholder="Employee Name"
            />
          </div>
          <div className="form-group full-width">
            <label htmlFor="designation">Designation</label>
            <input
              id="designation"
              type="text"
              value={designation}
              readOnly
              placeholder="Designation"
            />
          </div>
        </div>

        {/* Leave Type, Start Date, End Date Row */}
        <div className="leave-row">
          <div className="form-group">
            <label htmlFor="leaveType">Leave Type</label>
            <select
              id="leaveType"
              name="leaveType"
              value={leaveForm.leaveType}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Leave Type</option>
              <option value="sick">Sick Leave</option>
              <option value="casual">Casual Leave</option>
              <option value="annual">Annual Leave</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="startDate">Start Date</label>
            <input
              id="startDate"
              type="date"
              name="startDate"
              value={leaveForm.startDate}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="endDate">End Date</label>
            <input
              id="endDate"
              type="date"
              name="endDate"
              value={leaveForm.endDate}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        {/* Row for Reason for Leave and Supporting Document side by side */}
        <div className="leave-row">
          <div className="form-group">
            <label htmlFor="reason">Reason for Leave</label>
            <textarea
              id="reason"
              name="reason"
              value={leaveForm.reason}
              onChange={handleInputChange}
              required
              placeholder="Reason for Leave"
            />
          </div>
          <div className="form-group">
            <label htmlFor="photo">Supporting Document</label>
            <input
              id="photo"
              type="file"
              name="photo"
              onChange={handleFileChange}
              accept=".pdf,.jpg,.png"
            />
          </div>
        </div>

        {/* Form Actions */}
        <div className="form-actions">
          <button
            type="submit"
            className="leave-button leave-button-submit"
          >
            Submit Leave Request
          </button>
          <button
            type="button"
            onClick={handleViewLeaveResponse}
            className="leave-button leave-button-view"
          >
            {loadingResponse ? 'Loading...' : 'View Leave Response'}
          </button>
        </div>

        {message.text && (
          <p className={message.type === 'success' ? 'success' : 'error'}>
            {message.text}
          </p>
        )}

        {leaveResponse && (
          <div className="leave-response">
            <h4>Leave Response</h4>
            <p>Employee Name: {leaveResponse.empName}</p>
            <p>Designation: {leaveResponse.designation}</p>
            <p>Leave Status: {leaveResponse.response}</p>
            <p>
              Response Created At:{" "}
              {new Date(leaveResponse.created_at).toLocaleString()}
            </p>
          </div>
        )}
      </form>
    </div>

  );
};

export default LeavePortal;
